import Navigation from '@/components/navigation/Navigation'
import StaticContentUsePolicy from '@/components/statics/StaticContentUsePolicy'
import StaticContentPrivacyPolicy from '@/components/statics/StaticContentPrivacyPolicy'
import StaticContentTerms from '@/components/statics/StaticContentTerms'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/',
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'use-policy',
				name: 'StaticContentUsePolicy',
				components: {
					default: StaticContentUsePolicy,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-in',
					})
				}
			},
			{
				path: 'privacy-policy',
				name: 'StaticContentPrivacyPolicy',
				components: {
					default: StaticContentPrivacyPolicy,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-in',
					})
				}
			},
			{
				path: 'terms',
				name: 'StaticContentTerms',
				components: {
					default: StaticContentTerms,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						cssprop: 'logged-in',
					})
				}
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/statics.js